import React from 'react';
import { getAffiliationShortLabelFromRef } from '../../utils/affiliationHelpers';
import './AffiliationBadge.css';

const TONE_BY_CODE = {
  FUNTOA: 'funtoa',
  FUNHECE: 'funhece',
  FUNABE: 'funabe',
  FUNFIA: 'funfia'
};

/**
 * @param {{ affiliation?: object, variant?: 'compact' | 'stacked' }} props
 * affiliation : { code, label, city, shortLabel }
 */
export default function AffiliationBadge({ affiliation, className = '', variant = 'compact' }) {
  if (!affiliation) {
    return (
      <span className={`co-aff-badge co-aff-badge--unknown co-aff-badge--compact ${className}`.trim()}>
        —
      </span>
    );
  }

  const tone = TONE_BY_CODE[affiliation.code] || 'unknown';
  const isCompact = variant === 'compact';
  const orgLabel = affiliation.label || affiliation.code;
  const city = affiliation.city || '';

  if (isCompact) {
    return (
      <span
        className={`co-aff-badge co-aff-badge--compact co-aff-badge--${tone} ${className}`.trim()}
        title={getAffiliationShortLabelFromRef(affiliation)}
      >
        <span className="co-aff-badge__org">{orgLabel}</span>
        {city ? (
          <>
            <span className="co-aff-badge__sep" aria-hidden>
              ·
            </span>
            <span className="co-aff-badge__city">{city}</span>
          </>
        ) : null}
      </span>
    );
  }

  return (
    <span
      className={`co-aff-badge co-aff-badge--stacked co-aff-badge--${tone} ${className}`.trim()}
      title={getAffiliationShortLabelFromRef(affiliation)}
    >
      <span className="co-aff-badge__org">{orgLabel}</span>
      {city ? <span className="co-aff-badge__city">{city}</span> : null}
    </span>
  );
}
